<template>
  <div>
    <vs-input
        v-model="email"
        v-validate="'required|email|min:3'"
        class="w-full"
        data-vv-validate-on="blur"
        icon="icon icon-user"
        icon-no-border
        icon-pack="feather"
        label-placeholder="Email"
        name="email"
    />

    <span class="text-danger text-sm">
      {{ errors.first('email') }}
    </span>

    <div class="flex items-center">
      <vs-input
          v-model="password"
          v-validate="'required|min:6|max:20'"
          :type="showPassword ? 'text' : 'password'"
          class="w-full mt-6"
          data-vv-validate-on="blur"
          icon="icon icon-lock"
          icon-no-border
          icon-pack="feather"
          label-placeholder="Senha"
          name="senha"
      />

      <span>
        <vs-icon
          :icon="showPassword ? 'visibility_off' : 'visibility'"
          class="absolute icon-grow"
          style="right:.9em; font-size:23px; cursor:pointer; user-select:none;"
          @click="showPassword = !showPassword"
        />
      </span>
    </div>

    <span class="text-danger text-sm">
      {{ errors.first('password') }}
    </span>

    <div class="flex flex-wrap justify-between my-5 mb-3">
      <vs-button @click="login()">
        Login
      </vs-button>
    </div>
  </div>
</template>

<script>
import vue from '@/main'
import {getIp} from '@/utils'

export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      messageResponse: '',
      showPassword: false,
      verifyActivity: false,
    }
  },
  created() {
    vue.$on('api-response', this.handleApiResponse);
    const storedValue = localStorage.getItem('twoFactor');
    this.verifyActivity = storedValue === 'true'
  },
  methods: {
    handleApiResponse(response) {
      this.messageResponse = response.data.status
      return this.messageResponse;
    },
    async login() {
      try {
        const ip = await getIp();
        const response = await this.$store.dispatch('createTokenAction', {
          email: this.email,
          password: this.password,
          ip: ip
        });

        const has2FAEnabled = !!(response.data.user && response.data.user.twofactor_activity);
        localStorage.setItem('twoFactor', String(has2FAEnabled));
        if (has2FAEnabled) {
          this.$router.push('/two-factor');
        } else {
          this.$vs.notify({
            title: 'Sucesso!',
            text: 'Login realizado com sucesso',
            color: 'success',
          });

          await this.$store.dispatch('setName');
          await this.$store.dispatch('getAllUsers');

          this.$router.push('/user-settings');
          localStorage.removeItem('permissions');
        }
      } catch (exception) {
        console.error(this.messageResponse);
        this.$vs.notify({
          title: 'Erro!',
          color: 'danger',
          text: 'O email ou(e) senha esta(ão) incorreto(s)'
        });
      }
    }
  }
}

</script>